import api from './api.service';
import {Category, CourseData, CourseDataInfo, CourseMaterial, CourseMessage, Language, Level} from "../types";
import {AxiosResponse} from "axios";

class CourseService {
    getCourses() {
        return api.get(`course/me`)
    }

    getProfile() {
        return api.get(`course/profile/me`)
    }

    getCourseCategories() {
        return api.get('course/category');
    }

    createCourse(courseData: { name: string, category_id: string, planned_time: string }) {
        return api.post('course', {...courseData, planned_time: parseInt(courseData.planned_time)});
    }

    getCourseObjectives(course_id: string) {
        return api.get(`course/objectives/${course_id}`)
    }

    setCourseObjectives(course_id: string, items: string[]) {
        return api.post(`course/objectives`, {course_id, items});
    }

    getCourseRequirements(course_id: string) {
        return api.get(`course/requirements/${course_id}`)
    }

    setCourseRequirements(course_id: string, items: string[]) {
        return api.post(`course/requirements`, {course_id, items});
    }

    getCourseAuditory(course_id: string) {
        return api.get(`course/targets-audience/${course_id}`)
    }

    setCourseAuditory(course_id: string, items: string[]) {
        return api.post(`course/targets-audience`, {course_id, items});
    }

    updateCourseDetail(courseId: string, data: CourseData) {
        return api.put(`/course/detail/${courseId}`, data);
    }

    loadVideo(formData: FormData) {
        return api.post<{ url: string }>('/video', formData, {
            headers: {'Content-Type': 'multipart/form-data'}
        });
    }

    loadFile(fileBase64: string, fileName: string, fileExtension: string | undefined): Promise<AxiosResponse<{ image: string }>> {
        const payload = {
            file: fileBase64,
            file_name: fileName,
            file_extension: fileExtension
        };
        return api.post<{ image: string }>(`/course/lecture/file`, payload, {
            headers: {'Content-Type': 'application/json'}
        });
    }

    loadImage(courseId: string, imageBase64: string) {
        const payload = {
            file: imageBase64
        };
        return api.post<{ image: string }>(`/course/preview/${courseId}`, payload, {
            headers: {'Content-Type': 'application/json'}
        });
    }

    deleteVideo(video_id: any) {
        return api.delete(`/video/${video_id}`);
    }
    deletePreview(file_id: any) {
        return api.delete(`/course/preview/${file_id}`);
    }
    getPreview(file_id: any) {
        return api.get(`/course/preview/${file_id}`);
    }

    deleteFile(file_id: any) {
        return api.delete(`course/lecture/file/${file_id}`);
    }

    postCourseMessage(course_id: string, data: any) {
        return api.post(`/course/messages/${course_id}`, data);
    }

    putCourseMessage(course_id: string, welcome_message: string, congratulation_message: string) {
        return api.put(`/course/messages/${course_id}`, {welcome_message, congratulation_message});
    }

    putCoursePrice(course_id: string, price: number, requesite_id: string) {
        return api.put(`/course/price/${course_id}`, {price, requesite_id});
    }


    /*RQ*/
    getCourseLanguages = async (): Promise<Language[]> => {
        const response = await api.get('course/language');
        return response.data;
    };
    getCourseLevels = async (): Promise<Level[]> => {
        const response = await api.get('course/level');
        return response.data;
    };
    getCourseCategory = async (): Promise<Category[]> => {
        const response = await api.get('course/category');
        return response.data;
    };
    getCourseDetails = async (courseId: string): Promise<CourseData> => {
        const response = await api.get(`/course/detail/${courseId}`);
        return response.data;
    };
    getCourseInfo = async (courseId: string): Promise<CourseDataInfo> => {
        const response = await api.get(`/course/${courseId}`);
        return response.data;
    };
    getRecommendationsList = async () => {
        const response = await api.get(`/course/list/recommendations`);
        return response.data;
    };
    getCourseMessage = async (courseId: string): Promise<CourseMessage> => {
        const response = await api.get(`/course/messages/${courseId}`,);
        return response.data;
    }

    getCourseParts(courseId: string) {
        return api.get(`/course/parts/list/${courseId}`);
    }
    getCourseMaterial(courseId: string): Promise<CourseMaterial>{
        return api.get(`/course/parts/list/${courseId}`);
    }

    createCoursePart(courseId: string, partData: any) {
        return api.post('/course/parts', {course_id: courseId, ...partData,});
    }

    updateCoursePart(partId: string, partData: any) {
        return api.put(`/course/parts/${partId}`, partData);
    }

    deleteCoursePart(partId: string) {
        return api.delete(`/course/parts/${partId}`);
    }

    createCourseContent(partId: string, contentData: any) {
        return api.put(`/course/content/${partId}`, contentData);
    }

    deleteCourse(courseId: string) {
        return api.delete(`/course/${courseId}`);
    }

    getRecommendationCourses(data:string){
        return api.get(`/course/list/recommendations?${data}`)
    }
    getCoursesList(data:string){
        return api.get(`course/list?${data}`)
    }
}

export const courseService = new CourseService();
